<template>
    <div id="footer" data-app-id="footer" data-show-status="showFooter" class="full-width base-container">
        <div class="page-footer-style5 custom-clip bg-scale-style4 bg-repeat-style1 bg-align-style1"
            style="background: rgba(77, 53, 43, 1) ;font-family:&quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, &quot;PingFang SC&quot;, sans-serif;">
            <div style="color: rgba(255, 255, 255, 1);font-size: 16px !important;">
                <div class="w-content clear">
                    <ul>
                        <li class="page-footer-li">
                            <span style="display: inline-block">
                                <label>校址：</label><span>湖北省武汉市洪山区黄家湖西路3号 </span>
                            </span>
                            <span style="display: inline-block"><label>邮政编码:
                                </label><span>430065</span></span>
                            <span style="margin-right: 30px;display:inline-block">鄂ICP备14001708号</span>
                            <span style="margin-right: 30px;display:inline-block">鄂公网安备42011102001017号</span>
                            <br />
                        </li>
                        <li class="page-footer-li" style="margin-right: 30px;margin-bottom: 16px;text-align: center;">版权所有: 武汉工商学院图书馆 Copyright © 2023-2024 All rights
                                    reserved</li>
                        <li class="page-footer-li" >
                            <a style="display: inline-block;cursor: pointer;" v-for="(item, index) in newserjiArr" :index="index">
                                
                                <span @click="openLink(item.id)">{{ item.name }}</span>
                            </a>
                        </li>
                         
                        <li class="page-footer-li">
                            <span>
                                <span class="changeLanguage">总访问量：</span>
                                <span>{{ ztotal }}</span></span>

                            <span>
                                <span class="changeLanguage">年访问量：</span>
                                <span>{{ ztotalYear }}</span>
                            </span>
                            <span>
                                <span class="changeLanguage">今日访问量：</span>
                                <span>{{ ztotalDay }}</span>
                            </span>
                        </li>
                        <li class="page-footer-li">
                            <div class="page-footer-img" v-for="(item, index) in readerImg" :key="index">
                                <img :src="item.picUrl">
                                <p>{{ item.title }}</p>
                            </div>
                        </li>
                       
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { getUserInfo } from '@/common/utils/localStorage.js'
import { querynyrCountbyCondition } from "@/api/dataTotal"//获取访问量
import { queryimgebyId } from "@/api/bannerImg"//二维码
import { queryTreeflxx, } from "@/api/context1"//一二级分类
import { queryXwxxbyCondition, } from "@/api/news"//新闻
export default {
    name: 'Footer',
    data() {
        return {
            ztotal: [],
            ztotalYear: [],
            ztotalDay: [],
            readerImg: [],//二维码
            newserjiArr: [],
            tableData: [],
        }
    },
    mounted() {
        this.querynyrCountbyCondition()
        this.queryReader()
        this.queryTreeflxx()
    },
    methods: {
        //获取访问数量
        querynyrCountbyCondition() {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                fwtype: 1
            }
            querynyrCountbyCondition(obj).then((res) => {
                vm.ztotal = res.data[0].ztotal
                vm.ztotalYear = res.data[1].ztotal
                vm.ztotalDay = res.data[3].ztotal
            });
        },
        //二维码
        queryReader() {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                "type": 4,
            }
            queryimgebyId(obj).then((res) => {
                vm.readerImg = res.data
            });
        },
        queryTreeflxx() {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                type: 13
            }
            queryTreeflxx(obj).then((res) => {
                if (res.data == "") {

                } else {
                    vm.newserjiArr = res.data.splice(0, 10)
                    // vm.newKuaijie = res.data[7].childDisease
                    // vm.KuaijieId = res.data[7].id
                    // vm.topNavData = res.data.slice(7)
                    // vm.newserjiArr = vm.newserjiArr.splice(0,7)
                }
            });
        },
        // 查找新闻通知
        queryXwxxbyCondition(id) {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                flid: id,
            }
            queryXwxxbyCondition(obj).then((res) => {
                console.log(res.data.list[0].linkUrl);
                let link = res.data.list[0].linkUrl
                window.open(link)
            });
        },
        openLink(id){
            let vm = this;
            vm.queryXwxxbyCondition(id)
        }
    }
}
</script>

<style scoped lang="scss">
.page-footer-li span {
    padding-right: 10px;
}
.page-footer-li {
a {
        margin-right: 20px;
    }
}

#footer {
    font-size: 16px;
    line-height: normal;
    width: 100%;
    bottom: 0;
}

.clear {
    clear: none !important;
}

.item-drag-wrap {
    position: absolute !important;
}

.btn-module-container {
    z-index: 9998;
    box-sizing: border-box;
    border: 2px solid transparent;
}

.custom-clip.bg-align-style1 {
    background-position: left top !important;
    background-repeat: no-repeat !important;
}

.page-footer-style29 {
    color: #fff;
}

.page-footer-style29 .top-box .w-content {
    position: relative;
    margin: 0 auto;
    width: 1200px;
    height: 100%;
}

.page-footer-style29 .top-box .w-content .logo-img {
    width: auto;
    margin: 40px 0 0;
    max-height: 70px;
    max-width: 400px;
}

.page-footer-style29 .top-box .w-content .detail-box {
    margin: 32px 0 0;
    max-width: 350px;
}

.page-footer-style29 .top-box .w-content .detail-box .detail-item {
    max-width: 100%;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 8px;
    word-break: break-all;
}

.overHidden1 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.page-footer-style29 .top-box .w-content .link-box {
    position: absolute;
    top: 32px;
    left: 50%;
    transform: translateX(-50%);
}

.page-footer-style29 .top-box .w-content .link-box .link-list {
    margin-right: 80px;
    max-width: 140px;
}

.page-footer-style29 .top-box .w-content .link-box .link-list .link-title {
    font-size: 16px !important;
    font-weight: 500;
}

.page-footer-style29 .top-box .w-content .link-box .link-list .link-item {
    cursor: pointer;
    font-size: 14px;
    margin-bottom: 12px;
}

.overHidden2 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 1.6 !important;
}

.page-footer-style29 .top-box .w-content .code-box {
    position: absolute;
    right: 0;
    top: 31px;
}

.page-footer-style29 .top-box .w-content .code-box .code-item {
    display: inline-block;
    margin-right: 20px;
    width: 108px;
}

.page-footer-style29 .top-box .w-content .code-box .code-item .img-box {
    width: 100%;
    height: 108px;
    padding: 4px;
    background: #ffffff;
    border-radius: 8px;
    margin-bottom: 8px;
    box-sizing: border-box;
}

.page-footer-style29 .top-box .w-content .code-box .code-item .img-box>img {
    width: 100%;
    height: 100%;
}

.page-footer-style29 .top-box .w-content .code-box .code-item .code-txt {
    font-size: 14px;
    color: #ffffff;
    line-height: 20px;
    text-align: center;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
}

.page-footer-style29 .bottom-box {
    height: 49px;
    border-top: 1px solid rgba(238, 238, 238, 0.12);
}

.page-footer-style29 .bottom-box .bottom-content {
    width: 1200px;
    margin: 0 auto;
    font-size: 14px;
    text-align: center;
    line-height: 51px;
    font-size: 12px;
}

.page-footer-style29 .bottom-box .bottom-content>* {
    margin-right: 16px;
    color: #fff;

}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue